import React from 'react';

// Single-handle "how far" slider — the standard radius control. Native range
// input with a filled track and matching thumb. `value` is a number (km).
export default function RadiusSlider({ min, max, step = 1, value, onChange }) {
  const pct = Math.max(0, Math.min(100, ((value - min) / (max - min)) * 100));
  return (
    <div className="px-1 pt-1">
      <div className="relative h-6 flex items-center">
        <div className="absolute h-1 w-full rounded-full bg-gray-200" />
        <div className="absolute h-1 rounded-full bg-blue-600" style={{ width: `${pct}%` }} />
        <input
          type="range" min={min} max={max} step={step} value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          className="vvr-range" aria-label="Search radius (km)"
        />
      </div>
      <div className="flex justify-between text-[11px] text-gray-400 mt-1">
        <span>{min} km</span>
        <span>{max} km</span>
      </div>
      <style>{`
        .vvr-range { position:absolute; left:0; width:100%; margin:0; height:1rem; background:transparent; -webkit-appearance:none; appearance:none; cursor:pointer; }
        .vvr-range::-webkit-slider-runnable-track { background:transparent; border:none; }
        .vvr-range::-moz-range-track { background:transparent; border:none; }
        .vvr-range::-webkit-slider-thumb { -webkit-appearance:none; appearance:none; height:18px; width:18px; border-radius:9999px; background:#2563eb; border:2px solid #fff; box-shadow:0 1px 3px rgba(0,0,0,.35); margin-top:-8px; }
        .vvr-range::-moz-range-thumb { height:18px; width:18px; border-radius:9999px; background:#2563eb; border:2px solid #fff; box-shadow:0 1px 3px rgba(0,0,0,.35); }
      `}</style>
    </div>
  );
}
